import { handleActions } from "redux-actions";
import { axios } from "@cores/axiosWrapper";

function getRequestAPI(stageId, apiEndpoint, projectId, id) {
    const headers = {
        stageId,
    };

    if (projectId) {
        headers.projectId = projectId;
    }

    return axios.get(`${apiEndpoint}/requests/${id}`, {
        headers,
    });
}

function getMyRequestAPI(stageId, apiEndpoint, projectId, id) {
    const headers = {
        stageId,
    };

    if (projectId) {
        headers.projectId = projectId;
    }

    return axios.get(`${apiEndpoint}/my-requests/${id}`, {
        headers,
    });
}

function updateRequestAPI(stageId, apiEndpoint, projectId, id, data) {
    const headers = {
        stageId,
    };
    if (projectId) {
        headers.projectId = projectId;
    }
    return axios.patch(`${apiEndpoint}/requests/${id}`, data, {
        headers,
    });
}

export function updateRequestStatusAPI(stageId, apiEndpoint, projectId, id, data) {
    const headers = {
        stageId,
    };
    if (projectId) {
        headers.projectId = projectId;
    }
    return axios.put(`${apiEndpoint}/requests/${id}/status`, data, {
        headers,
    });
}

function updateRequestAssigneeAPI(stageId, apiEndpoint, projectId, id, data) {
    const headers = {
        stageId,
    };
    if (projectId) {
        headers.projectId = projectId;
    }
    return axios.put(`${apiEndpoint}/requests/${id}/assignee`, data, {
        headers,
    });
}

function approveShareRequestAPI(stageId, apiEndpoint, projectId, assetId, data) {
    const headers = {
        stageId,
    };
    if (projectId) {
        headers.projectId = projectId;
    }
    return axios.post(`${apiEndpoint}/assets/${assetId}/shares`, data, {
        headers,
    });
}

const initialState = {
    data: null,
    editPending: false,
    pending: false,
    error: null,
    editError: null,
};

const GET_REQUEST_PENDING = "GET_REQUEST_PENDING";
const GET_REQUEST_SUCCESS = "GET_REQUEST_SUCCESS";
const GET_REQUEST_FAILURE = "GET_REQUEST_FAILURE";
const GET_REQUEST_UPDATE_PENDING = "GET_REQUEST_UPDATE_PENDING";
const GET_REQUEST_UPDATE_SUCCESS = "GET_REQUEST_UPDATE_SUCCESS";
const GET_REQUEST_UPDATE_FAILURE = "GET_REQUEST_UPDATE_FAILURE";
const GET_REQUEST_UPDATE_STATUS_SUCCESS = "GET_REQUEST_UPDATE_STATUS_SUCCESS";
const GET_REQUEST_UPDATE_ASSIGNEE_SUCCESS = "GET_REQUEST_UPDATE_ASSIGNEE_SUCCESS";
const RESET_REQUEST = "RESET_REQUEST";

export default handleActions(
    {
        [GET_REQUEST_PENDING]: (state) => {
            return { ...state, pending: true, data: null, error: null };
        },
        [GET_REQUEST_SUCCESS]: (state, action) => {
            return { ...state, data: action.payload, pending: false };
        },
        [GET_REQUEST_FAILURE]: (state, action) => {
            return { ...state, pending: false, error: action.payload };
        },
        [GET_REQUEST_UPDATE_STATUS_SUCCESS]: (state, action) => {
            return { ...state, data: { ...state.data, status: action.payload }, pending: false };
        },
        [GET_REQUEST_UPDATE_ASSIGNEE_SUCCESS]: (state, action) => {
            const { id, name } = action.payload;
            return { ...state, data: { ...state.data, assigned: { to: { id, name } } }, pending: false };
        },
        [GET_REQUEST_UPDATE_PENDING]: (state) => {
            return { ...state, editPending: true, error: null };
        },
        [GET_REQUEST_UPDATE_SUCCESS]: (state) => {
            return { ...state, editPending: false, error: null };
        },
        [GET_REQUEST_UPDATE_FAILURE]: (state, action) => {
            return { ...state, editPending: false, editError: action.payload };
        },
        [RESET_REQUEST]: (state) => {
            return { ...initialState };
        },
    },
    initialState,
);

export const getRequest =
    ({ projectId, requestId }) =>
    (dispatch, getState) => {
        let { stage } = getState();

        dispatch({ type: GET_REQUEST_PENDING });
        return getRequestAPI(stage.id, stage.endpoint, projectId, requestId)
            .then(async (response) => {
                const results = response.data;
                dispatch({
                    type: GET_REQUEST_SUCCESS,
                    payload: results,
                });
            })
            .catch((error) => {
                dispatch({
                    type: GET_REQUEST_FAILURE,
                    payload: error.response,
                });
            });
    };

export const getMyRequest =
    ({ projectId, requestId }) =>
    (dispatch, getState) => {
        let { stage } = getState();

        dispatch({ type: GET_REQUEST_PENDING });
        return getMyRequestAPI(stage.id, stage.endpoint, projectId, requestId)
            .then(async (response) => {
                const results = response.data;
                dispatch({
                    type: GET_REQUEST_SUCCESS,
                    payload: results,
                });
            })
            .catch((error) => {
                dispatch({
                    type: GET_REQUEST_FAILURE,
                    payload: error.response,
                });
            });
    };

export const updateRequestStatus =
    ({ projectId, requestId, params }) =>
    (dispatch, getState) => {
        let { stage } = getState();

        return new Promise((resolve, reject) => {
            updateRequestStatusAPI(stage.id, stage.endpoint, projectId, requestId, params)
                .then(async (response) => {
                    dispatch({
                        type: GET_REQUEST_UPDATE_STATUS_SUCCESS,
                        payload: params.value,
                    });
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

export const updateRequestAssignee =
    ({ projectId, requestId, params }) =>
    (dispatch, getState) => {
        let { stage } = getState();

        return new Promise((resolve, reject) => {
            updateRequestAssigneeAPI(stage.id, stage.endpoint, projectId, requestId, { id: params.id })
                .then(async (response) => {
                    dispatch({
                        type: GET_REQUEST_UPDATE_ASSIGNEE_SUCCESS,
                        payload: params,
                    });
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

export const approveShareRequest =
    ({ projectId, assetId, data }) =>
    (dispatch, getState) => {
        let { stage } = getState();

        dispatch({ type: GET_REQUEST_UPDATE_PENDING });
        return new Promise((resolve, reject) => {
            approveShareRequestAPI(stage.id, stage.endpoint, projectId, assetId, data)
                .then(async (response) => {
                    dispatch({ type: GET_REQUEST_UPDATE_SUCCESS });
                    resolve(response);
                })
                .catch((error) => {
                    dispatch({ type: GET_REQUEST_UPDATE_FAILURE, payload: error });
                    reject(error);
                });
        });
    };
